import { withStyles } from '@material-ui/core';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import queryDuck from '@/features/merchantsPage/ducks/query';
import withQuerySync from '@/hocs/withQuerySync';

import {
  getMerchantIds,
  getMerchantsError,
  getMerchantsTotalCount,
  isLoadingMerchants,
} from '../selectors';
import Merchants from './component';
import styles from './styles';

const mapStateToProps = state => ({
  error: getMerchantsError(state),
  merchantIds: getMerchantIds(state),
  isLoading: isLoadingMerchants(state),
  totalCount: getMerchantsTotalCount(state),
});

export default compose(
  withQuerySync(queryDuck),
  connect(mapStateToProps),
  withStyles(styles),
)(Merchants);
